import 'src/client';
if (module.hot) {
    module.hot.accept();
}
//# sourceMappingURL=entrypoint.js.map